import Axios from "@/plugins/axios";

export default {
  namespaced: true,

  state: {
    phones: [],
    queues: [],
    error: false
  },
  getters: {
    phones: state => state.phones,
    queues: state => state.queues,
    error: state => state.error
  },
  mutations: {
    SET_PHONES: (state, payload) => state.phones = payload,
    SET_QUEUES: (state, payload) => state.queues = payload,
    SET_ERROR: (state, error) => state.error = error
  },
  actions: {
    all: async ({ commit }, payload) => {
      try {
        const response = await Axios.get("/api/extensions", payload);
        commit("SET_PHONES", response.data.phones);
        commit("SET_QUEUES", response.data.queues);
      } catch (e) {
        commit("SET_ERROR", e);
      }
    },

    clear: async ({ commit }) => {
      commit("SET_PHONES", []);
      commit("SET_QUEUES", []);
    }
  }
};